import React, { useState } from 'react';

import { Card, Row, Col , Modal} from 'react-bootstrap';
import { Paper, Avatar, ListItem, ListItemSecondaryAction, ListItemText, ListItemAvatar, List } from '@material-ui/core';
import './card.style.css';
import img from '../../images/1.png';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';


export default function LatestBiographie(props) {
    const [state , setState] = useState({
        show : false
    });
    const handleClose = () => setState({ ...state, show: false });
    let bio = props.data;
    return (
    <div class="col-md-3 ">
        <Card className="bg-transparent text-dark border-0 ">
            <Paper elevation={3}>
            <button
                type="button"
                className="bg-transparent border-0 p-0 play-icon-container"
                onClick={e => {
                    setState({show: true })
                }}>
                <img src={bio.video?.frame?.url} alt="video poster" className="rounded" width="100%" height="200px" />
                <div className="text-white play-icon row m-0 align-items-center">
                    <PlayCircleOutlineIcon className="col" style={{ height:"50px"}} />
                </div>
            </button>
            </Paper>
            <Card.ImgOverlay>
                <Row className="p-0">
                    <Col className="pl-3 text-light" xs={8}>
                        <p className="mb-0">{bio.title}</p></Col>
                    <Col className="text-light" xs={4}>
                        <p className="text-right mb-0">{bio.video?.duration} sec</p></Col>
                </Row>
            </Card.ImgOverlay>
            {/* <List dense> */}
                {/* <ListItem className="p-0">
                    <ListItemAvatar className="p-0">
                        <Avatar>
                            <Avatar alt="Cindy Baker" src="/static/images/avatar/3.jpg" />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText className="p-0" primary="John Doe" secondary="Mobile" />
                    <ListItemSecondaryAction className=" text-right">
                        <p className="text-grey pl-3">13 Nov 2019</p>
                    </ListItemSecondaryAction>
                </ListItem> */}
                {/* <Row className="p-0">
                    <Col className="pl-3 " xs={6}><p>{bio.title}</p></Col>
                    <Col className="" xs={{ span: 4, offset: 2 }}><p className="text-right">{bio.video?.duration}</p></Col>
                </Row> */}
            {/* </List> */}
        </Card>
        <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter pr-0"
            centered
            className="row m-0 modal-video"
            show={state.show}
            onHide={handleClose}>
            <Col xs={12} className="p-0">
                <Modal.Body className="p-0 bg-white rounded border-b-0">
                    <Col xs={12} className="text-left  bold  captialize">
                        <h6 className='mb-0 pt-3 pb-3'>{bio.title}</h6>
                    </Col>
                    <Col xs={12} className="p-0 bg-black ">
                        <video controls autoPlay title={bio.title} src={bio.video?.url} className='iframe-sm ' width="100%" style={{ maxHeight: '33rem' }}></video>
                    </Col>
                </Modal.Body>
            </Col>
        </Modal>
    </div>
    );
}
